import type { ChatMessageModel } from '../client/SmartAssistantBackendClient';

export const releaseSequencedBuffer = (params: {
  state: { nextSeq: number; buffer: Map<number, string>; lastSeq: number };
  merged: ChatMessageModel[];
  mergeMessages: (current: ChatMessageModel[], payload: any, eventName?: string) => ChatMessageModel[];
}) => {
  const { state, mergeMessages } = params;
  let { merged } = params;
  let released = false;

  while (state.buffer.has(state.nextSeq)) {
    const chunk = state.buffer.get(state.nextSeq) ?? '';
    state.buffer.delete(state.nextSeq);
    merged = mergeMessages(merged, { role: 'assistant', content: chunk, isPartial: true }, 'sequenced');
    state.lastSeq = Math.max(state.lastSeq, state.nextSeq);
    state.nextSeq += 1;
    released = true;
  }

  return { merged, released };
};
